/**
 * 去除字符串两端空格
 * @param value string
 */
export function trim(value) {
  return value.replace(/(^\s*)|(\s*$)/g, "");
}

/**
 * title换行
 */
export function titleMultiLine(str, cosNum) {
  if (!str) {
    return "";
  }
  if (!cosNum) {
    cosNum = 30;
  }
  let userAgent = window.navigator.userAgent;
  if (/webkit/i.test(userAgent)) {
    return str;
  } else {
    let ret = new RegExp("(.{" + cosNum + "})", "g");
    return str.replace(ret, "$1" + "\n");
  }
}
/**
 * 是否为非空字符串
 */
export function nonEmptyString(value) {
  return (
    Object.prototype.toString.call(value) === "[object String]" && value !== ""
  );
}

/**
 * undefined 转 空字符串
 */
export function noneToEmptyStr(value) {
  if (
    (!value || typeof value == "undefined" || value === "undefined") &&
    value != 0
  ) {
    // 当value为0 的时候，也会被判定为 !value, 所以再对value为0的情况做个判断
    return "";
  } else {
    return value;
  }
}
